module.exports = __webpack_public_path__ + "img/SSGPAY_KR.5950c7ea.png";